import { cn } from '../../lib/cn';
import type { EnrollmentRow } from '../../enterprisebeta/framework';

type Props = { pipeline?: EnrollmentRow[] };

export function CustomerEnrollmentPanel({ pipeline = [] }: Props) {
  return (
    <div className="space-y-2">
      {pipeline.map((e) => (
        <div key={e.stage} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{e.stage}</p>
            <p className="text-xs text-slate-500">{e.count} customers</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            e.status === 'signed' || e.status === 'approved' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
          )}>
            {e.status}
          </span>
        </div>
      ))}
    </div>
  );
}
